<template>
  <div>
    <title-bar title="单位管理">
      <el-button type="primary" @click="edit()" :loading="loading">添加</el-button>
    </title-bar>
    <div class="page-body">
      <el-form inline>
        <el-form-item label="单位名称">
          <el-input v-model="queryForm.compName" clearable placeholder="请输入单位名称模糊查询"></el-input>
        </el-form-item>
        <el-form-item label="停运日期">
          <code-select code-type="WEEKDAY" v-model="queryForm.stopDay" @change="query"></code-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.valid" clearable @change="query">
            <el-option :value="true" label="启用"></el-option>
            <el-option :value="false" label="禁用"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="compName" label="单位名称" min-width="300"></el-table-column>
        <column-code-type prop="compType" code-type="COMP_TYPE" label="单位类型" align="center" min-width="100"></column-code-type>
        <column-code-type prop="compLevel" code-type="areaLevel" label="单位层级" align="center" min-width="100"></column-code-type>
        <el-table-column prop="areaName" label="所属地区" align="center" min-width="150"></el-table-column>
        <column-code-type prop="stopDay" code-type="WEEKDAY" label="停运日期" align="center" min-width="100"></column-code-type>
        <el-table-column prop="valid" label="状态" align="center" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.valid" class="color-success">启用</span>
            <span v-else class="color-error">禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作" width="120" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="del(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" @change="loadData" :total="total"></table-pagination>
    </div>


  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CodeSelect from "@/components/base/CodeSelect";
import ColumnCodeType from "@/components/tableColumns/ColumnCodeType.vue";
export default {
  name: 'CompanyList',
  components: {ColumnCodeType, CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      queryForm: {
        compName: '',
        stopDay: null,
        valid: null,
        page: 1,
        limit: 10
      },
      records: [],
      total: 0
    }
  },
  created() {
    //重置缓存
    let cache = this.getComponentCache();
    if(cache) {
        this.queryForm = cache;
    }
    this.clearComponentCache();
    this.loadData();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/company/getCompanyList", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    edit(row) {
      this.saveCache();
      this.$router.push({
        path: "/companyEdit",
        query: {
          compId: row ? row.compId: null
        }
      })
    },
    saveCache() {
      this.setComponentCache(this.queryForm);
    },
    del(row){
      this.$confirm("确定要删除该单位吗？").then(()=>{
        this.loading = true;
        this.postForm("/company/deleteCompany", {
          compId: row.compId
        }, true).then(dr => {
          this.records = dr.rows;
          this.total = dr.total;
        }).finally(()=>{
          this.loading = false;
        })
      });
    }
  }
}
</script>

<style scoped>

</style>